// KycThankuController
app.controller('KycThankuController', ['$scope', 'sessionService', '$location', 'WdHttpService', 'config', '$sce', '$routeParams', '$timeout', 'analyticsService', '$ocLazyLoad',
    function($scope, sessionService, $location, WdHttpService, config, $sce, $routeParams, $timeout, analyticsService, $ocLazyLoad) {
        $ocLazyLoad.load(config.ENACH_SDK_URL);

        // Init 
        $scope.init = async function() {
            await $scope.fetchAdviserSiteDetails();
            $scope.showPageLoader();
            $scope.fund_details = undefined;
            $scope.investmentSipAmtOriginally = 0;
            $scope.sipDate = undefined;
            $scope.investmentPurpose = 'EQUITYSUBSCRIPTION'; //ADDITIONALSUBSCRIPTION, RENEWAL
            $scope.investingMode = 'REAL';

            $scope.isEnachEnabled = $scope.isAdviserPropertyEnabled($routeParams.adviserUsername, 'eNachEnabled');
            $scope.isPaytmDisabled = $scope.isAdviserPropertyEnabled($routeParams.adviserUsername, 'paytmDisabled');
            $scope.payment_type = $scope.isEnachEnabled ? "enach" : "paytm"; // select the default option for the user
            if ($routeParams.fund) {
                $scope.fundName = $routeParams.fund;
            } else if ($location.search().fund)
                $scope.fundName = $location.search().fund;
            else
                $scope.fundName = sessionService.get('fundName');

            // $scope.fundName = 'OpenQIndiaConsumptionTop500';
            if ($scope.fundName == undefined) {
                $scope.showErrorPopup('Sorry, you came with insufficient data on this page');
                return;
            }

            // Search the fund and get the amount of fee to be paid.
            var data = {
                q: "fundName:" + $scope.fundName,
                f: "web_admin:" + $scope.webadminName
            }
            await WdHttpService._get_funds(data)
                .then(async function(response) {
                    if (response.status == 200) {
                        // This if condition is coded due to a server side bug to be fixed yet.
                        if (response.data.Items.length == 1) {
                            $scope.fund_details = response.data.Items[0];
                        } else if (response.data.Items.length > 1) {
                            response.data.Items.forEach(fund => {
                                if (fund.fundName == $scope.fundName) {
                                    $scope.fund_details = fund;
                                }
                            });
                        }
                    } else {
                        $scope.fund_details = undefined;
                        $scope.showErrorPopup('This fund seems to have closed now, could not fetch fund details', () => { window.location.href = '/' });
                        return;
                    }

                    if (!$scope.fund_details.feePeriod)
                        $scope.fund_details.feePeriod = 6;

                    $scope.isAdviserResearchAnalyst = $scope.fund_details.wealthBasketType == 'RA' ? true : false;
                    if ($scope.fund_details.childFund != undefined) {
                        if ($scope.fund_details.childFund.length > 0) {
                            $scope.investmentSipAmtOriginally = parseInt($scope.fund_details.childFund[0].minAmount);
                            for (var i = 0; i < $scope.fund_details.childFund.length; i++) {
                                if ($scope.fund_details.childFund[i].minAmount < $scope.investmentSipAmtOriginally) {
                                    $scope.investmentSipAmtOriginally = parseInt($scope.fund_details.childFund[i].minAmount);
                                }
                            }
                        }
                    }

                }).catch(error => {
                    console.log(error);
                    $scope.showErrorMessagePayment("Could not fetch WealthBasket details, please reach out to us at support@wealthdesk.in or +91 8588 00 8835");
                    throw error;
                });
                
            // check if the user has signed the agreement with adviser or not
            await WdHttpService._get_user_adviser_analyst_agreement_status($routeParams.adviserUsername)
                .then(async response => {
                    $scope.analystAgreementStatus = response;
                    if ($scope.analystAgreementStatus != "SIGNED") {
                        if ($scope.analystAgreementStatus == "INPROGRESS") {
                            let agreementStatus = await WdHttpService._get_agreement_esign_status($routeParams.adviserUsername);
                            if (agreementStatus.status != "SIGNED") {
                                var redirectUrl = '/adviser-agreement/' + $routeParams.adviserUsername + '/' + $routeParams.fundName;
                                if (!$scope.isAdviserResearchAnalyst) {
                                    $scope.showErrorPopup("Your terms of service signing with adviser is pending, redirecting you to sign the agreement.", () => window.location.href = redirectUrl);
                                } else {
                                    $scope.showErrorPopup("Your agreement signing with adviser is pending, redirecting you to sign the agreement.", () => window.location.href = redirectUrl);
                                }
                                return;
                            }
                        } else {
                            if (!$scope.isAdviserResearchAnalyst) {
                                $scope.showErrorPopup("Your terms of service signing with adviser is not done, redirecting you to sign the agreement.", () => window.location.href = '/adviser-agreement/' + $routeParams.adviserUsername + '/' + $scope.fundName);
                            } else {
                                $scope.showErrorPopup("Your agreement signing with adviser is not done, redirecting you to sign the agreement.", () => window.location.href = '/adviser-agreement/' + $routeParams.adviserUsername + '/' + $scope.fundName);
                            }
                            return;
                        }
                    }
                }).catch(error => {
                    console.log(error);
                    if ($scope.isAdviserResearchAnalyst) {
                        $scope.showErrorPopup("Your terms of service is not signed, please reach out to us at support@wealthdesk.in or +91 8588 00 8835.", () => window.location.href = '/contact-us');
                    } else {
                        $scope.showErrorPopup("Your agreement status is not available, please reach out to us at support@wealthdesk.in or +91 8588 00 8835.", () => window.location.href = '/contact-us');
                    }
                });


            $scope.radio_investType = "LUMPSUM";
            $scope.hidePageLoader();
        }

        $scope.trustAction = function() {
            return $sce.trustAsResourceUrl(config.PAYTM_URL);
        };

        $scope.submitInvestingAmount = async function(amount, investmentType = "LUMPSUM") {
            $scope.showLoading('#confirmInvestmentAmount');
            if ($scope.isEnachEnabled) {
                $scope.isMandateRegistered = false;
                await WdHttpService._get_dynamodb_user_profile()
                    .then(async response => {
                        var adviserUsername = $routeParams.adviserUsername;
                        if ("advisortoMandateDetails" in response) {
                            if (adviserUsername in response.advisortoMandateDetails) {
                                $scope.isMandateRegistered = true;
                            }
                        }
                    })
            }
            $scope.paymentDetails = {};
            $scope.paymentDetails.investmentType = investmentType.toUpperCase();
            $scope.paymentDetails.investmentPurpose = $scope.investmentPurpose;
            var eventData = {
                'fundName': $scope.fundName.toLowerCase()
            };
            if (investmentType == 'SIP') {
                if ($scope.sipDate == undefined) {
                    $scope.showErrorPopup("Please select the SIP Day and proceed");
                    return;
                } else {
                    $scope.paymentDetails.sipDate = $scope.sipDate;

                    await analyticsService._push_custom_event_data_to_datalayer('sip-selected-' + $scope.investmentPurpose.toLowerCase(), eventData);
        
                }
                $scope.minimumAmountForAdvisoryPayment = parseInt($scope.investmentSipAmtOriginally);
            } else {

                await analyticsService._push_custom_event_data_to_datalayer('lumpsum-selected-' + $scope.investmentPurpose.toLowerCase(), eventData);
               
                $scope.minimumAmountForAdvisoryPayment = parseInt($scope.fund_details.minAmount);
                $scope.paymentDetails.sipDate = 0;
            }

            var validateMoreThanMinLumpsum = amount >= $scope.minimumAmountForAdvisoryPayment;
            if ($scope.fund_details && validateMoreThanMinLumpsum) {
                $scope.paymentDetails.investmentAmount = amount;
                $scope.distributorId = $scope.isAdviser ? $scope.fund_details.adviserUsername : sessionService.get("distributorName");
                await WdHttpService._get_user_advisory_fee_amount(
                    $scope.fundName,
                    $scope.fund_details.adviserUsername,
                    $scope.distributorId,
                    $scope.paymentDetails.investmentAmount,
                    $scope.investmentPurpose,
                    $scope.investingMode,
                    $scope.paymentDetails.investmentType
                ).then(async response => {
                    // if response.data.feeAmount is Zero then call is_fee_paid
                    $scope.paymentDetails.fee_key = response.data.key;
                    $scope.paymentDetails.feeAmount = response.data.feeAmount;
                    if ($scope.paymentDetails.feeAmount == 0) {
                        var data = {
                            purpose: $scope.investmentPurpose,
                            investingMode: $scope.investingMode,
                            investmentAmount: $scope.paymentDetails.investmentAmount,
                            investmentType: $scope.paymentDetails.investmentType,
                            fundName: $scope.fundName,
                            adviserUsername: $scope.fund_details.adviserUsername,
                            sipDay: $scope.paymentDetails.sipDate ? $scope.paymentDetails.sipDate : 0
                        }
                        WdHttpService._is_fee_paid(data)
                            .then(async response => {
                                var eventData = {
                                    'fundName': $scope.fundName.toLowerCase()
                                };
                                await analyticsService._push_custom_event_data_to_datalayer('subscription-fee-amount-zero-' + $scope.investmentPurpose.toLowerCase(), eventData);
                                if (config[$scope.brokerName])
                                    window.location.href = config[$scope.brokerName].orderPlacementUrl + "?orderId=" + response.data.orderId + "&action=order-placement&path=" + window.location.origin;
                                else {
                                    // considering its a offline broker
                                    window.location.href = '/order-placement' + "?orderId=" + response.data.orderId + "&action=order-placement&path=" + window.location.origin;
                                }
                            }).catch(error => {
                                $scope.showErrorPopup(error);
                                $scope.$evalAsync();
                            });
                    } else {
                        // display the payment display in UI 
                        $scope.paymentDetails.gstAmt = ($scope.paymentDetails.feeAmount * .18).toFixed(2);
                        $scope.paymentDetails.payment_charges = 0;
                        $scope.paymentDetails.totalAmt = parseFloat($scope.paymentDetails.feeAmount) + parseFloat($scope.paymentDetails.gstAmt) + parseFloat($scope.paymentDetails.payment_charges);
                        $scope.paymentDetails.totalAmt = $scope.paymentDetails.totalAmt.toFixed(2);
                        var eventData = {
                            'fundName': $scope.fundName.toLowerCase()
                        };
                        await analyticsService._push_custom_event_data_to_datalayer('subscribtion-fee-initiated-' + $scope.investmentPurpose.toLowerCase(), eventData);
                           
                        $scope.showPaymentDetails = true;
                    }                   

                }).catch(error => {
                    console.log(error);
                    $scope.showErrorPopup(error);
                })
            } else if (!validateMoreThanMinLumpsum) {
                $scope.showErrorPopup("Sorry, you have entered an amount less than the minimum required amount to invest, i.e. " + $scope.minimumAmountForAdvisoryPayment);
            }
            $scope.stopLoading('#confirmInvestmentAmount');
        }

        $scope.validateForm = function(form, investmentType) {
            if (form.$invalid)
                return true;
            else if (investmentType == 'SIP') {
                return $scope.sipDate == undefined
            }

            return false
        }

        $scope.datePicker = function(element) {
            $scope.sipDate = element;
            for (var i = 1; i < 29; i++) {
                var id = "object-".concat(i.toString());
                var sipDatePick = document.getElementById(id);
                sipDatePick.style.backgroundColor = "#80cbc4";
            }
            var id = "object-".concat(element.toString());
            var sipDatePick = document.getElementById(id);
            sipDatePick.style.backgroundColor = "#fff";
        }

        $scope.selectPayment = async function(paymentGateway) {
            if (!$scope.paymentDetails || !$scope.fund_details || !$scope.distributorId) {
                if (!$scope.paymentDetails)
                    $scope.showErrorPopup('Payment Details are incomplete, please reach out to us at support@wealthdesk.in or +91 8588 00 8835');
                if (!$scope.fund_details)
                    $scope.showErrorPopup('WealthBasket Details not found, please reach out to us at support@wealthdesk.in or +91 8588 00 8835');
                if (!$scope.distributorId)
                    $scope.showErrorPopup('Identifier is missing, please reach out to us at support@wealthdesk.in or +91 8588 00 8835');
                return;
            }
            if (paymentGateway == 'paytm') {               
                $scope.createPaytmOrder($scope.paymentDetails, $scope.fund_details, $scope.distributorId)
            } else if (paymentGateway == 'enach') {               
                if ($scope.isMandateRegistered) {
                    $scope.executeExistingMandate($scope.paymentDetails, $scope.fund_details);
                } else {
                    $scope.registerENachFlow($scope.paymentDetails, $scope.fund_details, $scope.distributorId)
                }
            }
        }

        //register mandate & open the popup or 
        $scope.registerENachFlow = async function(paymentDetails, fund_details, distributorId) {
            $scope.showPageLoader();
            var deploymentDetails = await WdHttpService._get_deployment_details(await WdHttpService._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
            const brokerBasedApiUrl = deploymentDetails.apiUrl;
            $scope.enach_data_request = {
                "adviserUsername": fund_details.adviserUsername,
                "distributor_id": distributorId,
                "fee_amount": paymentDetails.feeAmount,
                "fundName": fund_details.fundName,
                "gst_amount": paymentDetails.gstAmt,
                "investment_amount": paymentDetails.investmentAmount,
                "investment_type": paymentDetails.investmentType,
                "key": paymentDetails.fee_key,
                "period": fund_details.feePeriod,
                "purpose": paymentDetails.investmentPurpose,
                "sipDay": paymentDetails.sipDate ? paymentDetails.sipDate : 0,
                "callback_url": brokerBasedApiUrl,
                "caller_domain": location.host
            };
            await WdHttpService._post_mandate_registration($scope.enach_data_request)
                .then(response => {
                    let mandateData = response;
                    if (navigator.userAgent.includes('wv')) { //android webview check 
                        mandateData.features.enableNewWindowFlow = false;
                    }
                    $.pnCheckout(mandateData);
                    if (mandateData.features.enableNewWindowFlow) {
                        pnCheckoutShared.openNewWindow();
                    }
                    $scope.hidePageLoader();
                }).catch(error => {
                    $scope.showErrorMessagePayment(error);
                    $scope.hidePageLoader();
                    $scope.$evalAsync();
                });
        }

        $scope.showErrorMessagePayment = function(message) {
            $scope.isError = true;
            $scope.errorMessage = message;
            $timeout(function() {
                $scope.isError = false;
            }, 5000);
        }

        //mandate check if status completed
        $scope.executeExistingMandate = async function(paymentDetails, fund_details) {
            $scope.showPageLoader();
            $scope.data_request = {
                "fundName": fund_details.fundName,
                "adviserUsername": fund_details.adviserUsername,
                "investingMode": $scope.investingMode,
                "distributorUsername": $scope.distributorUsername ? $scope.distributorUsername : $routeParams.adviserUsername,
                "investingPurpose": paymentDetails.investmentPurpose,
                "investment_type": paymentDetails.investmentType,
                "investment_amount": paymentDetails.investmentAmount,
                "sipDay": paymentDetails.sipDate ? paymentDetails.sipDate : 0,
                "fee_amount": paymentDetails.feeAmount,
                "gst_amount": paymentDetails.gstAmt,
                "key": paymentDetails.fee_key
            };
            await WdHttpService._post_existing_mandate($scope.data_request)
                .then(response => {
                    let mandateOrderId = response.orderId;
                    window.location.href = config[$scope.brokerName].orderPlacementUrl + "?orderId=" + mandateOrderId + "&action=order-placement&path=https://" + window.location.hostname + ':' + window.location.port;
                    $scope.$evalAsync();
                }).catch(error => {
                    $scope.showErrorMessagePayment(error);
                    $scope.hidePageLoader();
                });
        }

        $scope.createPaytmOrder = async function(paymentDetails, fund_details, distributorId) {
            $scope.showPageLoader();
            var deploymentDetails = await WdHttpService._get_deployment_details(await WdHttpService._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
            const brokerBasedApiUrl = deploymentDetails.apiUrl + '/investor/';
            $scope.paytm_data_request = {
                TXN_AMOUNT: paymentDetails.totalAmt,
                FEE_AMOUNT: paymentDetails.feeAmount,
                GST_AMOUNT: paymentDetails.gstAmt,
                PAYMENT_CHARGES: paymentDetails.payment_charges,
                CALLBACK_URL: brokerBasedApiUrl + config.CALLBACK_URL,
                CALLER_DOMAIN: location.host,
                CHANNEL_ID: config.CHANNEL_ID,
                INDUSTRY_TYPE_ID: config.INDUSTRY_TYPE_ID,
                WEBSITE: config.WEBSITE,
                FUND_NAME: fund_details.fundName,
                ADVISER_USERNAME: fund_details.adviserUsername,
                "investment_amount": paymentDetails.investmentAmount,
                "purpose": paymentDetails.investmentPurpose,
                "investment_type": paymentDetails.investmentType,
                "sipDay": paymentDetails.sipDate ? paymentDetails.sipDate : 0,
                "key": paymentDetails.fee_key,
                "distributor_id": distributorId
            };
            await WdHttpService._create_order_checksum($scope.paytm_data_request)
                .then(response => {
                    $scope.paytm_data = response.data;
                    $scope.$evalAsync();
                    submitForm($scope);
                }).catch(error => {
                    $scope.showErrorMessagePayment(error);
                    $scope.hidePageLoader();
                });
        }

        function submitForm($scope, recursion = true) {
            setTimeout(() => {
                if (document.getElementById("btnPaytmSubmit")) {
                    document.getElementById("btnPaytmSubmit").click();
                } else {
                    if (recursion) {
                        submitForm($scope, false);
                    } else {
                        $scope.showErrorPopup("Sorry, we are not able to redirect to paytm currently. Please reach out to us at support@wealthdesk.in or +91 8588 00 8835.", () => window.location.href = '/contact-us');
                    }
                }
            }, 1000);
        }
    }
]);